module.exports = __webpack_public_path__ + "static/banner-298c070fcc9c6a2b824000fe40d011ab.png";